import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "q-pt-md q-px-md"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("em", null, "No law firms found.", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_accounts = _resolveComponent("search-accounts")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_accounts_list = _resolveComponent("accounts-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_search_accounts, {
      onLoaded: _ctx.onSearchResults,
      onCleared: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSearchResults = false))
    }, null, 8, ["onLoaded"]),
    _createVNode(_component_q_separator),
    (_ctx.items.length)
      ? (_openBlock(), _createBlock(_component_accounts_list, {
          key: 0,
          items: _ctx.items,
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:account', $event)))
        }, null, 8, ["items"]))
      : _createCommentVNode("", true),
    (_ctx.showSearchResults && !_ctx.items.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}